import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_CriticalIncidentReport = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_CriticalIncidentReport' className='file-pdf-document'>
            <div className='file-template'>

                <p>
                    <center>
                        <b>
                            Georgia Health Partners, LLC <br />
                            Critical Incident Report <br />
                            <span className='small'> Notify direct supervisor within 15 minutes of stabilizing the incident.</span>


                        </b>
                    </center>
                </p>

                <p>
                    <b>Directions: </b>  Please complete this form in its entirety, detailing the incident that occurred. Please sign this form, as it is not valid without the required signatures. This form is to be submitted to your immediate supervisor within 2 hours following the incident. If the incident occurred outside of business hours, this form is to be submitted to the supervisor the next business day.

                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Incident Date:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Time:</span> </td>
                        <td className='w-250'> <span className='eleHeader'> Location:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='txtTime' name='txtTime' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocation' name='txtLocation' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Supervisor called?</span>  </td>
                    </tr>
                    <tr>
                        <td className='w-50'> <input type='radio' id='rbSupervisorCalled_No' name='rbSupervisorCalled' className='add-only' value='No' /> No </td>
                        <td className='w-50'> <input type='radio' id='rbSupervisorCalled_Yes' name='rbSupervisorCalled' className='add-only' value='Yes' /> Yes: </td>
                        <td className='w-600'> <input type='text' id='txtSupervisorCalledYes' name='txtSupervisorCalledYes' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Date called:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Time called:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDateCalled' name='txtDateCalled' className='add-only' /> </td>
                        <td className='w-375'> <input type='time' id='txtTimeCalled' name='txtTimeCalled' className='add-only' /> </td>
                    </tr>
                </table>

                <p>
                    <center>
                        <strong>Persons Involved</strong>
                    </center>

                </p>
                <table>

                    <tr>
                        <td className='w-750'><b>Consumer (C1)</b></td>
                    </tr>
                    <tr>
                        <td className='w-187'> <span className='eleHeader'> Name:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> DOB:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Ethnicity:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='text' id='txtName_C1' name='txtName_C1' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDOB_C1' name='txtDOB_C1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtEthnicity_C1' name='txtEthnicity_C1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtPhone_C1' name='txtPhone_C1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>Consumer (C2)</b></td>
                    </tr>
                    <tr>
                        <td className='w-187'> <span className='eleHeader'> Name:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> DOB:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Ethnicity:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='text' id='txtName_C2' name='txtName_C2' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDOB_C2' name='txtDOB_C2' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtEthnicity_C2' name='txtEthnicity_C2' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtPhone_C2' name='txtPhone_C2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>Staff (S1)</b></td>
                    </tr>
                    <tr>
                        <td className='w-187'> <span className='eleHeader'> Name:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> DOB:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Ethnicity:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='text' id='txtName_S1' name='txtName_S1' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDOB_S1' name='txtDOB_S1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtEthnicity_S1' name='txtEthnicity_S1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtPhone_S1' name='txtPhone_S1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>Visitor (V1)</b></td>
                    </tr>
                    <tr>
                        <td className='w-187'> <span className='eleHeader'> Name:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> DOB:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Ethnicity:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='text' id='txtName_V1' name='txtName_V1' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDOB_V1' name='txtDOB_V1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtEthnicity_V1' name='txtEthnicity_V1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtPhone_V1' name='txtPhone_V1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'><b>Other (1): <input type='text' id='txtName_O1' name='txtName_O1' className='add-only w-250' /></b></td>
                    </tr>
                    <tr>
                        <td className='w-187'> <span className='eleHeader'> Name:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> DOB:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Ethnicity:</span> </td>
                        <td className='w-187'> <span className='eleHeader'> Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'> <input type='text' id='txtName_O1' name='txtName_O1' className='add-only' /> </td>
                        <td className='w-187'> <input type='date' id='txtDOB_O1' name='txtDOB_O1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtEthnicity_O1' name='txtEthnicity_O1' className='add-only' /> </td>
                        <td className='w-187'> <input type='text' id='txtPhone_O1' name='txtPhone_O1' className='add-only' /> </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Incident Type</span></td>

                    </tr>

                    <tr>
                        <td className='w-250'>
                            <b>STAFF-RELATED INCIDENT</b>
                            <br />
                            <ol>
                                <li> <input type='checkbox' id='rbStaffRelatedIncident_1' name='rbStaffRelatedIncident_1' className='add-only' value='StaffRelatedIncident_1' /> Medical Emergency</li>
                                <li>
                                    <input type='checkbox' id='rbStaffRelatedIncident_2' name='rbStaffRelatedIncident_2' className='add-only' value='StaffRelatedIncident_2' /> Personal Injury
                                    <ol>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_21' name='rbStaffRelatedIncident_21' className='add-only' value='StaffRelatedIncident_21' /> Staff Fall </li>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_22' name='rbStaffRelatedIncident_22' className='add-only' value='StaffRelatedIncident_22' /> Vehicle Accident</li>
                                    </ol>
                                </li>
                                <li>
                                    <input type='checkbox' id='rbStaffRelatedIncident_3' name='rbStaffRelatedIncident_3' className='add-only' value='StaffRelatedIncident_3' /> Misconduct
                                    <ol>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_31' name='rbStaffRelatedIncident_31' className='add-only' value='StaffRelatedIncident_21' /> Physical Assault</li>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_32' name='rbStaffRelatedIncident_32' className='add-only' value='StaffRelatedIncident_32' /> Sexual Assault</li>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_33' name='rbStaffRelatedIncident_33' className='add-only' value='StaffRelatedIncident_33' /> Sexual Activity (w/consumer)</li>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_34' name='rbStaffRelatedIncident_34' className='add-only' value='StaffRelatedIncident_34' /> Verbal threat/aggression</li>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_35' name='rbStaffRelatedIncident_35' className='add-only' value='StaffRelatedIncident_35' /> Unauthorized poss. of weapons</li>
                                    </ol>
                                </li>
                                <li>
                                    <input type='checkbox' id='rbStaffRelatedIncident_4' name='rbStaffRelatedIncident_4' className='add-only' value='StaffRelatedIncident_4' /> Illicit Substances
                                    <ol>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_41' name='rbStaffRelatedIncident_41' className='add-only' value='StaffRelatedIncident_41' /> Possession</li>
                                        <li> <input type='checkbox' id='rbStaffRelatedIncident_42' name='rbStaffRelatedIncident_42' className='add-only' value='StaffRelatedIncident_42' /> Under the influence</li>
                                    </ol>
                                </li>
                            </ol>
                        </td>

                        <td className='w-250'>
                            <b>CONSUMER-RELATED INCIDENT</b> <br />
                            <ol>
                                <li> <input type='checkbox' id='rbConsumerRelated_1' name='rbConsumerRelated_1' className='add-only' value='ConsumerRelated_1' />  Death</li>
                                <li> <input type='checkbox' id='rbConsumerRelated_2' name='rbConsumerRelated_2' className='add-only' value='ConsumerRelated_2' /> Alleged Abuse & Neglect

                                    <ol>
                                        <li> <input type='checkbox' id='rbConsumerRelated_21' name='rbConsumerRelated_21' className='add-only' value='ConsumerRelated_21' />  Physical Abuse</li>
                                        <li> <input type='checkbox' id='rbConsumerRelated_22' name='rbConsumerRelated_22' className='add-only' value='ConsumerRelated_22' />  Neglect</li>
                                        <li> <input type='checkbox' id='rbConsumerRelated_23' name='rbConsumerRelated_23' className='add-only' value='ConsumerRelated_23' />  Sexual Abuse</li>
                                        <li> <input type='checkbox' id='rbConsumerRelated_24' name='rbConsumerRelated_24' className='add-only' value='ConsumerRelated_24' />  Alleged Abuse by GHP Staff</li>
                                    </ol>
                                </li>
                                <li> <input type='checkbox' id='rbConsumerRelated_3' name='rbConsumerRelated_3' className='add-only' value='ConsumerRelated_3' />  Elder Abuse (65+)</li>
                                <li> <input type='checkbox' id='rbConsumerRelated_4' name='rbConsumerRelated_4' className='add-only' value='ConsumerRelated_4' />  Medical Emergency</li>
                                <li> <input type='checkbox' id='rbConsumerRelated_5' name='rbConsumerRelated_5' className='add-only' value='ConsumerRelated_5' />  Medication Error</li>
                                <li> <input type='checkbox' id='rbConsumerRelated_6' name='rbConsumerRelated_6' className='add-only' value='ConsumerRelated_6' /> Personal Injury
                                    <ol>
                                        <li> <input type='checkbox' id='rbConsumerRelated_61' name='rbConsumerRelated_61' className='add-only' value='ConsumerRelated_61' />  Consumer Fall </li>
                                        <li> <input type='checkbox' id='rbConsumerRelated_62' name='rbConsumerRelated_62' className='add-only' value='ConsumerRelated_62' />  Vehicle accident (w/GHP staff)</li>
                                    </ol>
                                </li>
                                <li> <input type='checkbox' id='rbConsumerRelated_7' name='rbConsumerRelated_7' className='add-only' value='ConsumerRelated_7' /> 1013 (Transport to ER) </li>
                                <li> <input type='checkbox' id='rbConsumerRelated_8' name='rbConsumerRelated_8' className='add-only' value='ConsumerRelated_8' /> Wandering/Elopement (w/GHP staff) </li>
                                <li> <input type='checkbox' id='rbConsumerRelated_9' name='rbConsumerRelated_9' className='add-only' value='ConsumerRelated_9' /> Physical altercation b/w consumers
                                </li>
                            </ol>
                        </td>





                        <td className='w-250'>
                            <b>ENVIRONMENTAL INCIDENT</b> <br />
                            <ol>
                                <li> <input type='checkbox' id='rbEnvironmental_1' name='rbEnvironmental_1' className='add-only' value='Environmental_1' /> Biohazard Accident

                                    <ol>
                                        <li> <input type='checkbox' id='rbEnvironmental_11' name='rbEnvironmental_11' className='add-only' value='Environmental_11' /> Exposure to Blood/Bodily Fluids </li>
                                        <li> <input type='checkbox' id='rbEnvironmental_12' name='rbEnvironmental_12' className='add-only' value='Environmental_12' /> Exposure to Mold & Fungi </li>
                                        <li> <input type='checkbox' id='rbEnvironmental_13' name='rbEnvironmental_13' className='add-only' value='Environmental_13' /> Exposure to bed bugs </li>
                                        <li> <input type='checkbox' id='rbEnvironmental_14' name='rbEnvironmental_14' className='add-only' value='Environmental_14' /> Outbreak of contagious illness </li>
                                    </ol>
                                </li>
                                <li> <input type='checkbox' id='rbEnvironmental_2' name='rbEnvironmental_2' className='add-only' value='Environmental_2' /> Power Failure (impacting meds)  </li>
                                <li> <input type='checkbox' id='rbEnvironmental_3' name='rbEnvironmental_3' className='add-only' value='Environmental_3' /> Threats (Bomb/Homicidal) </li>
                                <li> <input type='checkbox' id='rbEnvironmental_4' name='rbEnvironmental_4' className='add-only' value='Environmental_4' /> Property Damage </li>
                                <li> <input type='checkbox' id='rbEnvironmental_5' name='rbEnvironmental_5' className='add-only' value='Environmental_5' /> Theft </li>
                                <li> <input type='checkbox' id='rbEnvironmental_6' name='rbEnvironmental_6' className='add-only' value='Environmental_6' /> Media </li>
                            </ol>
                        </td>
                    </tr>

                </table>
                <p>
                    <span className='eleHeader'>Incident Description</span>
                    Please include specific event and behavioral description of the incident. Please include the names of all witnesses. Add additional pages if needed.
                    <textarea id='txtIncidentDescription' name='txtIncidentDescription' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Supervisor Recommendation</span>
                    <textarea id='txtSupervisorRecommendation' name='txtSupervisorRecommendation' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Immediate Actions Taken </span>
                    Add additional pages if needed
                    <textarea id='txtImmediateActions' name='txtImmediateActions' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Other Pertinent Information </span>

                    This may include Individual's diagnosis, if applicable, allergies, medication, and other information that will assist in the resolution of the incident)

                    <textarea id='txtOtherPertinentInformation' name='txtOtherPertinentInformation' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Injury Follow-Up Detail:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbInjuryFollowUpDetail_1' name='rbInjuryFollowUpDetail_1' className='add-only' value='InjuryFollowUpDetail_1' /> Off-site Medical Care</td>
                        <td className='w-250'> <input type='checkbox' id='rbInjuryFollowUpDetail_2' name='rbInjuryFollowUpDetail_2' className='add-only' value='InjuryFollowUpDetail_2' /> Physician or Nurse On-site</td>
                        <td className='w-250'> <input type='checkbox' id='rbInjuryFollowUpDetail_3' name='rbInjuryFollowUpDetail_3' className='add-only' value='InjuryFollowUpDetail_3' /> First-Aid Care</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbInjuryFollowUpDetail_4' name='rbInjuryFollowUpDetail_4' className='add-only' value='InjuryFollowUpDetail_4' /> No Care</td>
                        <td className='w-250'> <input type='checkbox' id='rbInjuryFollowUpDetail_5' name='rbInjuryFollowUpDetail_5' className='add-only' value='InjuryFollowUpDetail_5' /> N/A</td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Emergency Contact Follow-Up:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbEmergencyContact_1' name='rbEmergencyContact_1' className='add-only' value='EmergencyContact_1' /> 911 Emergency/Ambulance</td>
                        <td className='w-250'> <input type='checkbox' id='rbEmergencyContact_2' name='rbEmergencyContact_2' className='add-only' value='EmergencyContact_2' /> Poison Control</td>
                        <td className='w-250'> <input type='checkbox' id='rbEmergencyContact_3' name='rbEmergencyContact_3' className='add-only' value='EmergencyContact_3' /> Fire Department</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbEmergencyContact_4' name='rbEmergencyContact_4' className='add-only' value='EmergencyContact_4' /> Police Department</td>
                        <td className='w-250'> <input type='checkbox' id='rbEmergencyContact_5' name='rbEmergencyContact_5' className='add-only' value='EmergencyContact_5' /> Family member</td>
                        <td className='w-250'> <input type='checkbox' id='rbEmergencyContact_6' name='rbEmergencyContact_6' className='add-only' value='EmergencyContact_6' /> Emergency contact person</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='rbEmergencyContact_8' name='rbEmergencyContact_8' className='add-only' value='EmergencyContact_8' />

                            Other:
                            <input type='text' id='txtEmergencyContact_Other' name='txtEmergencyContact_Other' className='w-250 add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbEmergencyContact_7' name='rbEmergencyContact_7' className='add-only' value='EmergencyContact_7' /> N/A</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'> Universal precautions taken?</span>
                    <input type='radio' id='rbUniversalPrecautions_Yes' name='rbUniversalPrecautions' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbUniversalPrecautions_No' name='rbUniversalPrecautions' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbUniversalPrecautions_Na' name='rbUniversalPrecautions' className='add-only' value='Na' /> N/A
                </p>
                <p>
                    <span className='eleHeader'> If staff injured, HR was notified?</span>
                    <input type='radio' id='rbHrNotified_Yes' name='rbHrNotified' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHrNotified_No' name='rbHrNotified' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbHrNotified_' name='rbHrNotified' className='add-only' value='Na' /> Na
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Person notified:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Date Notified:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPersonNotified' name='txtPersonNotified' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDateNotified' name='txtDateNotified' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Indicate attached documents:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_1' name='rbIndicateAttachedDocuments_1' className='add-only' value='IndicateAttachedDocuments_1' /> Progress Note</td>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_2' name='rbIndicateAttachedDocuments_2' className='add-only' value='IndicateAttachedDocuments_2' /> Medication Error Report</td>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_3' name='rbIndicateAttachedDocuments_3' className='add-only' value='IndicateAttachedDocuments_3' /> DFCS Report</td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_4' name='rbIndicateAttachedDocuments_4' className='add-only' value='IndicateAttachedDocuments_4' /> Evacuation/Safety Drill Form</td>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_5' name='rbIndicateAttachedDocuments_5' className='add-only' value='IndicateAttachedDocuments_5' /> DBHDD Death Report 04-106</td>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_6' name='rbIndicateAttachedDocuments_6' className='add-only' value='IndicateAttachedDocuments_6' /> DBHDD Critical Incident Report</td>

                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_7' name='rbIndicateAttachedDocuments_7' className='add-only' value='IndicateAttachedDocuments_7' /> DBHDD Safety Plan</td>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_8' name='rbIndicateAttachedDocuments_8' className='add-only' value='IndicateAttachedDocuments_8' /> Receipts of Professional Services</td>
                        <td className='w-250'> <input type='checkbox' id='rbIndicateAttachedDocuments_9' name='rbIndicateAttachedDocuments_9' className='add-only' value='IndicateAttachedDocuments_9' /> Self-Inspection</td>

                    </tr>
                    <tr>
                        <td className='w-500'> <input type='checkbox' id='rbIndicateAttachedDocuments_10' name='rbIndicateAttachedDocuments_10' className='add-only' value='IndicateAttachedDocuments_10' /> Dept of Community Health (DATEP)
                        </td>

                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Print Name </td>
                        <td className='small w-250'> Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

                <p>
                    <strong>
                        Director/Compliance Officer
                    </strong>
                </p>


                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature </td>
                        <td className='small w-375'> Date Report Received </td>
                    </tr>
                </table>


                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>
                </p>



            </div>
        </form>

    )
}